import { Box, Grid } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IVendor, indexVendor } from 'wisestep-api';
import {
  WsAutocompleteInput,
  WsButton,
  WsButtonGroup,
  WsColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import WsCheckBox from '../../../../components/WsCheckBox/WsCheckBox';
import { useGetVendor } from '../../hooks';
interface SubscriptionForm {
  isAllowEmails: boolean;
  subscriptionType: string;
  skills: string[];
}
const VendorSubscriptionPreferences = () => {
  const methods = useForm<SubscriptionForm>({
    defaultValues: {
      isAllowEmails: true,
      subscriptionType: 'JobsAndCandidates',
    },
  });
  const [params] = useSearchParams();
  const vendor = useGetVendor(params.get('code') ?? '');
  const navigate = useNavigate();

  const unsubscribeLink =
    'https://recruiter.wisestep.com/vendors/unsubscribe?scope=' +
    vendor.workspaceId +
    '&who=' +
    vendor.email +
    '&id=' +
    vendor.id +
    '&senderorg=' +
    vendor.organization;
  const onFromSubmit = (d: SubscriptionForm) => {
    vendor.skills = d.skills;
    vendor.subscriptionType = d.subscriptionType;
    vendor.subscriptionStatus = 'Accepted';
    vendor.emailBounceStatus = 'Valid';
    if (d.isAllowEmails) vendor.subscriptionFrom = 'Everyone';

    updatePref({ ...vendor });
  };
  const updatePref = async (v: IVendor) => {
    const res = await indexVendor(v);
    if (res.data) {
      navigate('/subscribed');
    }
  };
  return (
    <FormProvider {...methods}>
      <Box component="form" m={4} onSubmit={methods.handleSubmit(onFromSubmit)}>
        <Box p={4} mt={2} borderRadius={2} bgcolor={WsColors.White}>
          <Box textAlign="center" pb={2}>
            <WsTypography bold variant={WsTypoVariants.TITLE}>
              Update Email Preferences
            </WsTypography>
          </Box>
          <WsButtonGroup
            inputTitle="Send me Emails regarding"
            buttonsList={['Jobs', 'Candidates', 'JobsAndCandidates']}
            selectedIndexValue={(index: number, value: string) =>
              methods.setValue('subscriptionType', value)
            }
            defaultValue={2}
          />

          <Box width="40%" py={2}>
            <WsAutocompleteInput
              label="Relevent Skills"
              name={'skills'}
              options={[]}
              placeholder={'Enter skills comma seperated'}
              freeSolo={true}
              multiple={true}
            />
          </Box>
          <WsCheckBox name="isAllowEmails" label="Allow recruiters on WiseStep to send Emails" />
          <Grid xs={6} pt={1}>
            <WsButton variant="contained" type="submit">
              Update Preference
            </WsButton>
            <WsButton variant="text" onClick={() => navigate(unsubscribeLink)}>
              Unsubscribe
            </WsButton>
          </Grid>
        </Box>
      </Box>
    </FormProvider>
  );
};
export default VendorSubscriptionPreferences;
